import { Component, OnInit, Input } from '@angular/core';
import {FormGroup,FormBuilder} from '@angular/forms';

@Component({
  selector: 'estado-fecha-ingreso-salida',
  templateUrl: './estado-fecha-ingreso-salida.component.html',
  styles: []
})
export class EstadoFechaIngresoSalidaComponent implements OnInit {
  @Input() estadoFechas: FormGroup
  @Input() preview: boolean = true
  @Input() maxAnio:10
  @Input() minAnio:10
  
  constructor() { }

  ngOnInit() {
  }
 
  onSettingDate(d){
    let date = new Date()
    d.minDate= {year: date.getFullYear() - this.minAnio, month: 1, day: 1}
    d.maxDate = {year: date.getFullYear() + this.maxAnio, month: 12, day: 31}
    d.toggle()
  }
  onChangeEstado(){
    if(this.estadoFechas.get('glbEstado').value == 0){
      let date = new Date()
      this.estadoFechas.get('fechaSalida').patchValue({
        year: date.getFullYear() ,
        month:date.getMonth()+1 ,
        day : date.getDate() 
      })
      this.estadoFechas.get('fechaSalida').enable()
    }else{
      this.estadoFechas.get('fechaSalida').reset()
      this.estadoFechas.get('fechaSalida').disable()
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/element/formularios/estado-fecha-ingreso-salida.component.ts